//
//
//
//
//
//
//
//
export default {
  name: 'ListTitle',
  props: {
    /**
     * 标题
     */
    title: {
      type: String
    },

    /**
     * 描述内容
     */
    desc: {
      type: String
    }
  }
};